import { ROLE_IDS } from "../../../constants/roles.ts"

interface InvoiceCodes {
  project_invoice_create?: boolean
  project_invoice_edit?: boolean
}

export interface InvoiceAddPermissions {
  generateAllowed: boolean
  externalAllowed: boolean
}

/**
 * Which kinds of invoice a user may add, decided once for every add control.
 *
 * Mirrors the backend: generating makes a draft (`project_invoice_create`) and
 * then issues or sends it (`project_invoice_edit`), and a customer never
 * generates; recording an external invoice is a create alone.
 */
export const invoiceAddPermissions = (
  codes: InvoiceCodes | null | undefined,
  roleId: number | null | undefined
): InvoiceAddPermissions => {
  const create = Boolean(codes?.project_invoice_create)
  const edit = Boolean(codes?.project_invoice_edit)
  return {
    generateAllowed: create && edit && roleId !== ROLE_IDS.CUSTOMER,
    externalAllowed: create
  }
}
